import request from '@/utils/request'

/**
 * 获取金币列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listGold(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/gold.listGold',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新金币信息
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateGold(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/gold.updateGold',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除金币
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteGold(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/gold.deleteGold',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}